export const SET_AUTH_USER = "SET_AUTH_USER";
export const REMOVE_AUTH_USER = "REMOVE_AUTH_USER";
export const ADD_ITEM_TO_CART = "ADD_ITEM_TO_CART";
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const CONFIRM_ORDER = "CONFIRM_ORDER";
export const CANCEL_ORDER = "CANCEL_ORDER";
export const ADD_ITEM_TO_WISHLIST = "ADD_ITEM_TO_WISHLIST";
export const REMOVE_ITEM_FROM_WISHLIST = "REMOVE_ITEM_FROM_WISHLIST";
export const UPDATE_WISHLIST_ITEM = "UPDATE_WISHLIST_ITEM";
export const SET_CART_FROM_FIREBASE = "SET_CART_FROM_FIREBASE";
export const REMOVE_CART_ITEMS = "REMOVE_CART_ITEMS";
export const SET_WISHLIST_FROM_FIREBASE = "SET_WISHLIST_FROM_FIREBASE";
export const REMOVE_WISHLIST_ITEMS = "REMOVE_WISHLIST_ITEMS";
export const ADD_USER_ADDRESS = "ADD_USER_ADDRESS";
export const SET_ORDERS_FROM_FIREBASE = "SET_ORDERS_FROM_FIREBASE";
export const REMOVE_ORDERS = "REMOVE_ORDERS";
export const SET_LANGUAGE = "SET_LANGUAGE";
